export enum LockedAccountEnum {
    UploadLocked = 'uploadLocked',
    Unlocked = 'unlocked',
}
